import { useHttp } from '@/api';
import { httpApi } from '@/api/api';
import { t } from '@/locales';
import { contractionList } from "@/utils/const";
import { Message, Modal } from '@tellus/component';
const success = 'message.success.process'
export default {
  // 検索画面の初期化
  InitSearch(params) {
    return new Promise((resolve, reject) => {
      useHttp()
        .request(httpApi.GetUserInfoData, params, {
          errCallback: err => {
            reject(err)
          }
        })
        .then(res => {
          resolve(res)
        })
    })
  },

  // 新規画面/変更画面の初期化
  Init(data, isEntry) {
    return new Promise(resolve => {
      useHttp()
        .request(isEntry ? httpApi.UserInitEntry : httpApi.UserInitChange, isEntry ? null : data)
        .then(res => {
          resolve(res)
        })
    })
  },
  // 新規
  Entry(data, callback) {

     useHttp()
          .request(httpApi.CreateUserInfoData, data)
          .then(() => {
            // Modal.showSuccess('', t(success, [t('resource.button.entry')])).then(() => {
            //   callback()
            // })
            Message.showSuccess(t('message.COMMON_MESSAGE.ADD_SUCCESS'))

            callback()
          })
       .catch(err => {
         if (err.data != null) {
           contractionList.key = err.data.Data;
           if (err.data.Messages[0].Id === "userId") {
             Modal.showWarning("", t("message.COMMON_MESSAGE." + err.data.Messages[0].Message), {
               confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
             });
           }else{
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
           }
            } else {
              Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
            }
          })
  },

  // 変更
  Change(data, callback) {

     useHttp()
          .request(httpApi.ChangeUserInfoData, data)
          .then(() => {
            Message.showSuccess(t('message.COMMON_MESSAGE.UPDATE_SUCCESS'))

            callback()
          })
          .catch(err => {
            if (err.data != null) {
            contractionList.key = err.data.Data;
           if (err.data.Messages[0].Id === "userId") {
             Modal.showWarning("", t("message.COMMON_MESSAGE." + err.data.Messages[0].Message), {
               confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
             });
           }else{
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
           }
            } else {
              Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
            }
          })
  },
  // リセットパスワード
  ResetPassword(data, callback) {
    Modal.showInfo('', t('message.confirm.operation'), {
      $type: 'prompt',
      confirmButtonText: t('resource.button.sure'),
      cancelButtonText: t('resource.button.cancel'),
      showCancelButton: true
    })
      .then(() => {
        useHttp()
          .request(httpApi.UserResetPassword, data)
          .then(() => {
            Modal.showSuccess('', t(success, [t('resource.userManager.pwdReset')]))
              .then(() => {
                callback()
              })
              .catch(() => {})
          })
      })
      .catch(() => {})
  },

    // 検索画面の初期化
  GetUserInfoData(data) {
    return new Promise((resolve, reject) => {
      useHttp()
        .request(httpApi.GetUserInfoData,data)
        .then(res => {
          resolve(res)
        })
      .catch(err => {
        reject(err)
      })
    })
  },

  // 検索画面の初期化
  GetUserInfoDataById(data) {
    return new Promise((resolve, reject) => {
      useHttp()
        .request(httpApi.GetUserInfoDataById,data)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
        reject(err)
      })
    })
  },

  // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 start↓
  GetLoginUserInfoById(data) {
    return new Promise((resolve, reject) => {
      useHttp()
        .request(httpApi.GetLoginUserInfoById,data)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
        reject(err)
      })
    })
  },

  // 認証コードのチェック、信頼デバイスを設定
  ChkCodeSetTrustDev(data) {
    return new Promise((resolve, reject) => {
      useHttp()
        .request(httpApi.ChkCodeSetTrustDev,data)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
        reject(err)
      })
    })
  },
  // ADD 2025/11/13 ZLL 課題_ユーザログインのMFA認証処理の追加 end↑

  // 削除
  DelUserInfoData(data) {
    return new Promise((resolve, reject) => {
      useHttp()
        .request(httpApi.DelUserInfoData,data)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
        reject(err)
      })
    })
  },

/**
 * 部門のリスト取得
 */
 InitUserDepartmentList() {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.InitUserDepartmentList)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


}
